<template>
	<div>
		<!-- 留言按钮 -->
		<Comment class="commentWrap"/>
		<!-- 置顶组件 -->
		<gotop></gotop>
		
		<div class="bannertop">
			<!-- 顶部导航栏 -->
			<Headernew/> 
			<div class="bannertop-black">
				<div class="bannertop-right">
					<div class="wow fadeInUp bannertop-title">
						<div>科技赋能 智享未来</div>
						<div>| VR全景/视频 | 科技展厅</div>
						<div>| 人机互动程序定制 | 营销获客程序 </div>
					</div>
					
					<div class="dotojump" @click="jumppage">
						<div class="wow fadeInUp jumpbtn">
							查看案例
						</div>
					</div>
				</div>

			</div>
			
		</div>
		
		<div class="maincontent" v-html="contentmessage">
			{{contentmessage}}
		</div>
		
		<Footernew/> 
	</div>
</template>

<script scoped="scoped">
	import $ from "jquery"
	import Headernew from '@/components/Headernew.vue'
	import Footernew from '@/components/Footernew.vue'
	import {WOW} from 'wowjs'  //导入wow
	import Comment from '@/components/comment.vue'
	import gotop from '@/components/gotop.vue'
	export default {
		name: '',
		data() {
			return {
				contentmessage:'',//富文本信息
				jumpid:'',//要跳转的地址id
			}
		},
		components: {
		  Headernew,
		  Footernew,
		  Comment,
		  gotop
		},

		mounted() {
			// 在项目加载完成之后初始化wow
			this.$nextTick(() => {
				let wow = new WOW({
					live:false
				})
				wow.init()
			})
			
			this.requestcontent()
		},

		methods:{
			// 请求富文本信息
			requestcontent:function(){
							 
				 //带参数的get请求
				 // let url = "https://htkja.htkjbd.com/api/get/view3"
				 let newurl = this.$api + "/get/view3"
				 this.$axios.get(newurl)
				 .then((res) => {
					console.log(res)
					this.contentmessage = res.data.result.value
					this.jumpid = res.data.result.type
				 })
				 .catch((err) => {
					 console.log(err) //错误信息
				 })
			},
			
			// 跳转到案例列表页面的锚文本
			jumppage:function(){
				var select = this.jumpid
				localStorage.setItem('id',select)
				console.log(select,localStorage)
				this.$router.push({name:'videolist'})
			},
		}
	}
</script>

<style scoped="scoped">
	body{
		margin: 0;
		padding: 0;
	}
	/* 评论组件 */
	.commentWrap{
		position: fixed;
		left: 0;
		top: 0;
		z-index: 100;
	 }
	.bannertop{
		width: 100%;
		height: 800px;
		background-image: url(https://lubanhui1.oss-cn-beijing.aliyuncs.com/htkj/imgs/mediabanner3.jpg);
		background-size: 100% 100%;
		background-repeat: no-repeat;
	}
	.bannertop img{
		width: 100%;
		height: 100%;
	}
	.bannertop-black{
		width: 100%;
		height: 100%;
		background-color: rgba(0,0,0,0.2);
		position: relative;
	}
	.bannertop-right{
		width: 50%;
		height: 100%;
		position: absolute;
		right: 0;
		top: 0;
	}
	.bannertop-title{
		width: 100%;
		position: absolute;
		left: 0;
		top: 32%;
	}
	.bannertop-title div:nth-of-type(1){
		width: 100%;
		text-align: left;
		font-size: 61px;
		color: #fff;
		font-weight: bold;
	}
	.bannertop-title div:nth-of-type(2){
		width: 100%;
		text-align: left;
		font-size: 31px;
		color: #fff;
		margin-top: 30px;
		letter-spacing: 2px;
	}
	.bannertop-title div:nth-of-type(3){
		width: 100%;
		text-align: left;
		font-size: 31px;
		color: #fff;
		margin-top: 20px;
		letter-spacing: 2px;
	}
	.dotojump{
		width: 100%;
		display: flex;
		/* justify-content: center; */
		align-items: center;
		position: absolute;
		left: 0;
		bottom: 230px;
	}
	.jumpbtn:hover{
		cursor: pointer;
	}
	.jumpbtn{
		width: 140px;
		height: 40px;
		background-color: #fff;
		border-radius: 20px;
		text-align: center;
		line-height: 40px;
		letter-spacing: 1px;
		font-weight: bold;
		font-family: '微软雅黑';
	}
	
	
	/* 富文本信息 */
	.maincontent{
		width: 100%;
		/* width: 90%; */
		margin: 0px auto 0;
	}
	
	/* 手机端自适应 */
	@media (min-width: 300px) and (max-width: 500px){
		.bannertop{
			width: 100%;
			height: 250px;
		}
		.bannertop-right{
			width: 100%;
			height: 100%;
			position: absolute;
			right: 0;
			top: 0;
		}
		.bannertop-title{
			width: 100%;
			position: absolute;
			left: 0%;
			top: 40%;
		}
		.bannertop-title div:nth-of-type(1){
			width: 100%;
			text-align: center;
			font-size: 20px;
			color: #fff;
			font-weight: bold;
		}
		.bannertop-title div:nth-of-type(2){
			width: 100%;
			text-align: center;
			font-size: 14px;
			color: #fff;
			margin-top: 10px;
			letter-spacing: 2px;
		}
		.bannertop-title div:nth-of-type(3){
			width: 100%;
			text-align: center;
			font-size: 14px;
			color: #fff;
			margin-top: 10px;
			letter-spacing: 2px;
		}
		.dotojump{
			width: 100%;
			display: flex;
			/* justify-content: center; */
			align-items: center;
			position: absolute;
			left: 0;
			bottom: 250px;
		}
		
		/* 富文本信息 */
		.maincontent{
			/* width: 90%; */
			width: 100%;
			margin: 5px auto 0;
		}
		.dotojump{
			width: 100%;
			display: flex;
			justify-content: center;
			align-items: center;
			position: absolute;
			left: 0;
			bottom: 20px;
		}
		.jumpbtn:hover{
			cursor: pointer;
		}
		.jumpbtn{
			width: 100px;
			height: 25px;
			background-color: #fff;
			border-radius: 15px;
			text-align: center;
			line-height: 25px;
			letter-spacing: 1px;
			font-weight: bold;
			font-size: 12px;
		}
		
	}
	
	
	
	/* pad端 */
	@media (min-width: 500px) and (max-width: 800px){
		.bannertop{
			width: 100%;
			height: 400px;
			background-size: 100% 100%;
			background-repeat: no-repeat;
		}
		.bannertop-right{
			width: 55%;
			height: 100%;
			position: absolute;
			right: 0;
			top: 0;
		}
		.bannertop-title{
			width: 100%;
			position: absolute;
			left: 0;
			top: 35%;
		}
		.bannertop-title div:nth-of-type(1){
			width: 100%;
			text-align: left;
			font-size: 24px;
			color: #fff;
			font-weight: bold;
		}
		.bannertop-title div:nth-of-type(2){
			width: 100%;
			text-align: left;
			font-size: 16px;
			color: #fff;
			margin-top: 20px;
			letter-spacing: 2px;
		}
		.bannertop-title div:nth-of-type(3){
			width: 100%;
			text-align: left;
			font-size: 16px;
			color: #fff;
			margin-top: 15px;
			letter-spacing: 2px;
		}
		
		
		/* 富文本信息 */
		.maincontent{
			/* width: 90%; */
			width: 100%;
			margin: 5px auto 0;
		}
		.dotojump{
			width: 100%;
			display: flex;
			/* justify-content: center; */
			align-items: center;
			position: absolute;
			left: 0;
			bottom: 90px;
		}
		.jumpbtn:hover{
			cursor: pointer;
		}
		.jumpbtn{
			width: 100px;
			height: 25px;
			background-color: #fff;
			border-radius: 15px;
			text-align: center;
			line-height: 25px;
			letter-spacing: 1px;
			font-weight: bold;
			font-size: 12px;
		}
		
	}
	
	/* 老板仓定制机的样式 */
	@media (min-width: 1000px) and (max-width: 1300px){
		/* 评论组件 */
		.commentWrap{
			position: fixed;
			left: 0;
			top: 0;
			z-index: 100;
		 }
		.bannertop{
			width: 100%;
			height: 450px;
			background-image: url(https://lubanhui1.oss-cn-beijing.aliyuncs.com/htkj/imgs/mediabanner3.jpg);
			background-size: 100% 100%;
			background-repeat: no-repeat;
		}
		.bannertop img{
			width: 100%;
			height: 100%;
		}
		.bannertop-black{
			width: 100%;
			height: 100%;
			background-color: rgba(0,0,0,0.2);
			position: relative;
		}
		.bannertop-right{
			width: 50%;
			height: 100%;
			position: absolute;
			right: 0;
			top: 0;
		}
		.bannertop-title{
			width: 100%;
			position: absolute;
			left: 0;
			top: 32%;
		}
		.bannertop-title div:nth-of-type(1){
			width: 100%;
			text-align: left;
			font-size: 40px;
			color: #fff;
			font-weight: bold;
		}
		.bannertop-title div:nth-of-type(2){
			width: 100%;
			text-align: left;
			font-size: 20px;
			color: #fff;
			margin-top: 20px;
			letter-spacing: 2px;
		}
		.bannertop-title div:nth-of-type(3){
			width: 100%;
			text-align: left;
			font-size: 20px;
			color: #fff;
			margin-top: 10px;
			letter-spacing: 2px;
		}
		.dotojump{
			width: 100%;
			display: flex;
			/* justify-content: center; */
			align-items: center;
			position: absolute;
			left: 0;
			bottom: 80px;
		}
		.jumpbtn:hover{
			cursor: pointer;
		}
		.jumpbtn{
			width: 140px;
			height: 40px;
			background-color: #fff;
			border-radius: 20px;
			text-align: center;
			line-height: 40px;
			letter-spacing: 1px;
			font-weight: bold;
			font-family: '微软雅黑';
		}
		
		
		/* 富文本信息 */
		.maincontent{
			width: 100%;
			/* width: 90%; */
			margin: 0px auto 0;
		}
	}
</style>
